import React from 'react'

import Link from 'next/link'

import Content from '@nexys/components/Content/Content'
import Text from '@nexys/components/Typography/Text'
import { Button, Col, Row, Tooltip } from 'antd'
import { BASE_URL } from 'constant'

import styles from './footer.module.scss'

function Footer() {
  const dateNow = new Date()
  const yearNow = dateNow.getFullYear()
  const socialMediaData = [
    {
      icon: `${BASE_URL}/icon/ig.svg`,
      name: 'instagram',
      url: 'https://www.instagram.com/thelavanderesidences/',
      tooltip: 'Instagram',
    },
    {
      icon: `${BASE_URL}/icon/mail.svg`,
      name: 'email',
      url: 'mailto:customercare@lavande.id',
      tooltip: 'Email Customer Service',
    },
    {
      icon: `${BASE_URL}/icon/mail.svg`,
      name: 'email',
      url: 'mailto:pengelola@lavande.id',
      tooltip: 'Email Pengelola',
    },
  ]

  return (
    <Content
      id={'contributors'}
      component={(props) => <footer {...props} />}
      style={{
        padding: 16,
        color: '#fafafa',
        background: '#7F39C1',
        // width: '100%',
      }}
      styleContainer={{
        backgroundColor: '#7F39C1',
      }}
    >
      <Row gutter={[0, 16]} justify={`space-between`}>
        <Col
          xs={24}
          sm={24}
          md={12}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div>
            <div className={`w-full ${styles.mobile}`}>
              {socialMediaData.map((d) => {
                return (
                  <Link href={d?.url}>
                    <Button type="link">
                      <img src={d?.icon} alt={d?.name} />
                    </Button>
                  </Link>
                )
              })}
            </div>
            <hr className={`h-[1px] w-full ${styles.mobile}`} />
            <Text
              size={14}
              style={{
                color: '#fafafa',
              }}
            >
              &copy;&nbsp;
              {yearNow}
              &nbsp;The Lavande Residences. All rights reserved
            </Text>
            <div>
              <Text
                size={12}
                style={{
                  color: '#fafafa',
                }}
              >
                Badan Hukum Selain PT PERHIMPUNAN PEMILIK DAN PENGHUNI SATUAN
                RUMAH SUSUN APARTEMEN THE LAVANDE RESIDENCES
              </Text>
            </div>
          </div>
        </Col>
        <Col
          xs={12}
          style={{ display: 'flex', justifyContent: 'end' }}
          className="max-sm:hidden"
        >
          {socialMediaData.map((d) => {
            return (
              <Link href={d?.url}>
                <Tooltip placement="top" title={d?.tooltip}>
                  <Button
                    type="link"
                    style={{
                      background: 'rgb(200 152 245)',
                      padding: '5px 10px',
                      margin: '0px 3px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={d?.icon} alt={d?.name} />
                  </Button>
                </Tooltip>
              </Link>
            )
          })}
        </Col>
      </Row>
    </Content>
  )
}

export default Footer
